var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["infoTypeName", _vm.rules.name],
                    expression: "['infoTypeName', rules.name]",
                  },
                ],
                attrs: { placeholder: "最多输入6个字", "max-length": 6 },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "上级分组" } },
            [
              _c("a-tree-select", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["parentId"],
                    expression: "['parentId']",
                  },
                ],
                attrs: {
                  "allow-clear": "",
                  "dropdown-style": { maxHeight: "300px", overflow: "auto" },
                  treeData: _vm.treeData,
                  replaceFields: {
                    children: "children",
                    title: "infoTypeName",
                    key: "infoTypeId",
                    value: "infoTypeId",
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "排序" } },
            [
              _c("a-input-number", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["sortNum", _vm.rules.sortNum],
                    expression: "['sortNum', rules.sortNum]",
                  },
                ],
                attrs: {
                  min: 1,
                  controls: "false",
                  placeholder: "请输入分组排序",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }